module.exports = __webpack_public_path__ + "static/media/info-purple.e0e847c2.svg";